import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatBadgeModule } from '@angular/material/badge';

export interface TabItem {
  label: string;
  icon?: string;
  badgeCount?: number;
}

@Component({
  selector: 'app-custom-tabs',
  standalone: true,
  imports: [CommonModule, MatBadgeModule],
  templateUrl: './custom-tabs.component.html',
  styleUrls: ['./custom-tabs.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CustomTabsComponent {
  @Input() tabs: TabItem[] = [];
  @Input() selectedIndex = 0;

  @Output() tabChange = new EventEmitter<number>();

  onTabClick(index: number) {
    this.tabChange.emit(index);
  }
}